var React = require('react');

function CloudUpload (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.71 20.07C37.35 13.19 31.28 8 24 8c-5.78 0-10.79 3.28-13.3 8.07C4.69 16.72 0 21.81 0 28c0 6.63 5.37 12 12 12h26c5.52 0 10-4.48 10-10 0-5.28-4.11-9.56-9.29-9.93zM28 26v8h-8v-8h-6l10-10 10 10h-6z"}));
}

CloudUpload.displayName = "CloudUpload";

CloudUpload.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = CloudUpload;

CloudUpload.default = CloudUpload;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/cloud_upload.svg